import React, { useState } from 'react';
import './Header.css';
import logo from '../assets/logo-2.png';

function Header() {
  const [menuActive, setMenuActive] = useState(false);

  const toggleMenu = () => {
    setMenuActive(!menuActive); // Alterna entre abrir e fechar o menu
  };

  return (
    <header className="header">
      <nav className="navbar">
        <div className="navbar-logo">
          <a href="#home">
            <img src={logo} alt="Leal Transporte Executivo" />
          </a>
        </div>
        <div className="navbar-toggle" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <ul className={`navbar-menu ${menuActive ? 'active' : ''}`}>
          <li><a href="#home" onClick={toggleMenu}>Início</a></li>
          <li><a href="#services" onClick={toggleMenu}>Serviços</a></li>
          <li><a href="#about" onClick={toggleMenu}>Sobre</a></li>
          <li><a href="#contact" onClick={toggleMenu}>Contato</a></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
